import { UserProfile } from './user/user.type';
import { OnboardingStep } from './onboarding/onboarding.type';

export const determineOnboardingStepFromFlags = (user: UserProfile): OnboardingStep | null => {
  if (user.hasCompletedPTest) {
    return OnboardingStep.OnboardingCompleted;
  }
  if (user.hasSubmittedDocumentsForVerification) {
    return OnboardingStep.UploadDocuments;
  }
  if (user.hasCompletedLookingFor) {
    return OnboardingStep.RolePreferences;
  }
  if (user.hasCompletedProfessionalDescriptionPage) {
    return OnboardingStep.Skills;
  }
  if (user.isProfileCompleted) {
    return OnboardingStep.RecentProject;
  }
  if (user.hasCompletedProfileInfo) {
    return OnboardingStep.PersonalInfo;
  }
  if (user.hasVerifiedPhoneNumber) {
    return OnboardingStep.PhoneNumber;
  }

  return null;
};

export const getLastCompletedStep = (user: UserProfile, stepOrder: OnboardingStep[]): OnboardingStep | null => {
  // If onboardingStep is explicitly null, user hasn't completed any step
  if (user.webOnboarding && user.webOnboarding.onboardingStep === null) {
    return null;
  }

  // If user has explicit onboardingStep in webOnboarding and it's valid
  if (user.webOnboarding?.onboardingStep && stepOrder.includes(user.webOnboarding.onboardingStep)) {
    return user.webOnboarding.onboardingStep;
  }

  return determineOnboardingStepFromFlags(user);
};
